/**
 * @generated SignedSource<<79595e6159ca37d500d0e0a7dd3e2c88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteOccurrenceModalFragment$data = {
  readonly event: {
    readonly id: string;
    readonly isRecurring: boolean;
    readonly occurrences: {
      readonly totalCount: number;
    };
    readonly productId: string;
  };
  readonly id: string;
  readonly " $fragmentType": "DeleteOccurrenceModalFragment";
};
export type DeleteOccurrenceModalFragment$key = {
  readonly " $data"?: DeleteOccurrenceModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteOccurrenceModalFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteOccurrenceModalFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRecurring",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceNodeConnection",
          "kind": "LinkedField",
          "name": "occurrences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};
})();

(node as any).hash = "56bcd27952ee5b7838e8e3404ccf520d";

export default node;
